import { Dialog, DialogActions, DialogTitle } from '@mui/material'
import { DialogCloseSaveButtons } from 'components/Common/DialogActionButtons/DialogCloseSaveButtons'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { bomItemActivityByWorkingStepSelector } from 'features/BillOfMaterials/store/selectors/activities/bomItemActivityByWorkingStepSelector'
import { WorkingStepsContent } from 'features/BomItemDetailsDialog/DetailsTabs/WorkingSteps/WorkingStepsContent'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useState } from 'react'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppSelector } from 'store/configureStore'
import { useUnsavedChangesGuardOptions } from 'utils/useUnsavedChangesGuard'

export type WorkingStepMultipleItemsDialogProps = {
  bomItemPointers: Array<BomItemPointer>
  open: boolean
  onClose: () => void
}

export const WorkingStepMultipleItemsDialog = (
  props: WorkingStepMultipleItemsDialogProps,
) => {
  const { markClean, markDirty, wrapBlockedAction, ConfirmDialog } =
    useUnsavedChangesGuardOptions({
      manuallyRenderConfirmDialog: true,
    })

  const [activeWorkingStep, setActiveWorkingStep] =
    useState<WorkingStepType>(undefined)

  const activity = useAppSelector(
    bomItemActivityByWorkingStepSelector(
      props.bomItemPointers[0],
      activeWorkingStep,
    ),
  )

  const handleClose = wrapBlockedAction({
    action: () => {
      props.onClose()
    },
    actionName: 'close-working-steps-multiple-items-dialog',
    opts: {
      autoSave: false,
    },
  })

  return (
    <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth="xl">
      {ConfirmDialog}
      <DialogTitle component="div">
        <LocalizedTypography
          translationKey="project:working-steps"
          variant="h6"
        >
          working steps
        </LocalizedTypography>

        <LocalizedTypography
          translationKey="project:working-steps-multiple-items-description"
          variant="caption"
          component="p"
          color="textSecondary"
          defaultValue="changes will be applied to {{count}} items"
          options={{
            count: props.bomItemPointers.length,
          }}
        />
      </DialogTitle>
      <div
        style={{
          position: 'relative',
          height: '80vh',
        }}
      >
        <WorkingStepsContent
          affectedBomItemPointers={props.bomItemPointers}
          markClean={markClean}
          markDirty={markDirty}
          activeWorkingStep={activity}
          setActiveWorkingStep={setActiveWorkingStep}
        />
      </div>
      <DialogActions
        sx={{
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <DialogCloseSaveButtons
          onCloseButtonClicked={handleClose}
          hideSaveButton
          cancelButtonTranslationKey="common:close"
        />
      </DialogActions>
    </Dialog>
  )
}
